import { memo, useMemo, useEffect, useCallback } from 'react'
import { Box, Divider, Flex, Heading, IconButton, SimpleGrid, Text } from '@chakra-ui/react'

import { ArrowLeft, ArrowRight } from 'components/icons'
import useCalendar from './hook/useCalendar'
import CalendarCard from '../../localComponents/CalendarCard'
import SingleCalendarItem from './components/SingleCalendarItem'
import { useCalendarFilters } from '../../contexts/CalendarFiltersManager/Provider'
import { getStringInPhraseFormat } from 'utils/transforms/string'

function SingleCalendar() {
  const currentMonth = new Date().getMonth()
  const { startDate, dateFilterType, feedbackDateString } = useCalendarFilters()
  const { resetCalendar, daysInCalendar, nextMonth, previousMonth, stringMonth, year } = useCalendar(currentMonth)

  const daysOfTheWeek = useMemo(() => {
    return ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab']
  }, [])

  const getMonthFromStringDate = useCallback((stringDate: string) => {
    const splitedDate = stringDate.split('/')
    const month = Number(splitedDate[1])
    return month - 1
  }, [])

  const getYearFromStringDate = useCallback((stringDate: string) => {
    const splitedDate = stringDate.split('/')
    const year = Number(splitedDate[2])
    return year
  }, [])

  useEffect(() => {
    if (startDate) {
      const month = getMonthFromStringDate(startDate)
      const year = getYearFromStringDate(startDate)
      resetCalendar(month, year)
    }
  }, [startDate])

  if (dateFilterType === '') return null

  return (
    <>
      <Box width="100%" my={2}>
        <Divider borderColor="borderColor" />
      </Box>

      <Heading color="primary" mb={2}>
        {getStringInPhraseFormat(`${dateFilterType}${feedbackDateString}`)}
      </Heading>
      <CalendarCard bg="light">
        <Flex justify="space-between" align="center">
          <IconButton
            size="xs"
            variant="ghost"
            rounded="full"
            aria-label="Ir para o mês anterior"
            icon={<ArrowLeft />}
            onClick={previousMonth}
            _hover={{ bg: 'primary', color: 'light' }}
          />

          <Text color="primary" fontSize="md">
            {stringMonth} de {year}
          </Text>

          <IconButton
            size="xs"
            variant="ghost"
            rounded="full"
            aria-label="Ir para o próximo mês"
            icon={<ArrowRight />}
            onClick={nextMonth}
            _hover={{ bg: 'primary', color: 'light' }}
          />
        </Flex>

        <SimpleGrid columns={7} gap={2}>
          {daysOfTheWeek.map((week, index) => (
            <Flex justify={{ base: 'flex-start', md: 'center' }} pt={4} key={index}>
              <Text fontSize="xs">{week}</Text>
            </Flex>
          ))}

          {daysInCalendar.map(({ stringDate, day, isThisMounth }) => {
            return <SingleCalendarItem key={stringDate} stringDate={stringDate} day={day} isThisMounth={isThisMounth} />
          })}
        </SimpleGrid>
      </CalendarCard>
    </>
  )
}

export default memo(SingleCalendar)
